module.exports = __webpack_public_path__ + "img/coinloan.3b7ed384.svg";